import { Box } from "@mui/material";
import React from "react";
import { Button, InputDate } from "../../../controls";
import { subDays } from "date-fns";
import moment from "moment";

const FilterByDateRange = ({ setSearchTerm, searchTerm }) => {
  const handleDate = (name, newVal) => {
    setSearchTerm((x) => ({ ...x, [name]: newVal }));
  };

  const handleClear = () => {
    setSearchTerm((j) => ({
      ...j,
      fromDate: "",
      toDate: "",
    }));
  };

  return (
    <Box className="flex items-center justify-center gap-2">
      <InputDate
        variant="outlined"
        size="small"
        name="fromDate"
        value={searchTerm.fromDate}
        views={["day", "month", "year"]}
        openTo="day"
        minDate={new Date("01/01/2000")}
        maxDate={subDays(new Date(searchTerm.toDate), 1)}
        onChange={(date) =>
          handleDate("fromDate", new Date(date).toLocaleDateString())
        }
      />
      <span className=" text-[16px] text-gray-500">TO</span>
      <InputDate
        variant="outlined"
        size="small"
        name="toDate"
        value={searchTerm.toDate}
        minDate={moment(searchTerm.toDate, "MM/DD/YYYY").add(1, "days")}
        views={["day", "month", "year"]}
        openTo="day"
        onChange={(date) =>
          handleDate("toDate", new Date(date).toLocaleDateString())
        }
      />
      {(searchTerm.fromDate || searchTerm.toDate) && (
        <div>
          <Button onClick={handleClear} variant="text">
            Clear
          </Button>
        </div>
      )}
    </Box>
  );
};

export default FilterByDateRange;
